import React, { useEffect, useRef, useState } from 'react';

import './TerminalInput.scss';

import ABOUT_ME from './about-me';
import { CommandTypes, VALID_COMMANDS } from './HistoryItemRenderer';

export interface ICommand {
	input: string;
	type?: CommandTypes;
}

function TerminalInput({ onEnter }: { onEnter: (command: ICommand) => void }) {
	const [value, setValue] = useState('');

	const inputEl = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		const handleFocus = () => {
			inputEl.current?.focus();
		};

		window.addEventListener('click', handleFocus);

		return () => window.removeEventListener('click', handleFocus);
	}, []);

	const handleInputKeyDown = (
		event: React.KeyboardEvent<HTMLInputElement>,
	) => {
		if (event.key === 'Enter') {
			const trimmedValue = value.trim();

			if (
				Object.keys(ABOUT_ME).includes(trimmedValue) ||
				VALID_COMMANDS.includes(trimmedValue)
			) {
				onEnter({
					input: value,
					type: trimmedValue,
				});
			} else if (trimmedValue === '') {
				onEnter({ input: value });
			} else {
				onEnter({
					input: value,
					type: 'notFound',
				});
			}

			setValue('');
		}
	};

	return (
		<>
			<input
				aria-label="Please type a command. Press 'Enter' to submit."
				autoFocus
				className="terminal-input text"
				onChange={(e) => setValue(e.target.value)}
				onKeyDown={handleInputKeyDown}
				ref={inputEl}
				spellCheck="false"
				type="text"
				value={value}
			/>
		</>
	);
}

export default TerminalInput;
